(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    if (menu.dataset.mobileMenuReady === 'true') return;
    menu.dataset.mobileMenuReady = 'true';

    const trigger = menu.querySelector(':scope > summary');
    const panel = menu.querySelector('[data-mobile-menu-panel]');
    const closeButton = menu.querySelector('[data-mobile-menu-close]');
    const backdrop = menu.querySelector('[data-mobile-menu-backdrop]');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let closeTimer;
    let destination;

    const focusableElements = () => Array.from(
      panel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')
    ).filter((element) => element.getClientRects().length > 0);

    const finishClose = () => {
      window.clearTimeout(closeTimer);
      menu.open = false;
      menu.classList.remove('is-closing', 'is-opening');
      const nextDestination = destination;
      destination = undefined;
      if (nextDestination) {
        window.location.href = nextDestination;
      } else {
        trigger.focus({ preventScroll: true });
      }
    };

    const closeMenu = (nextDestination) => {
      if (!menu.open || menu.classList.contains('is-closing')) return;
      destination = nextDestination;
      menu.classList.remove('is-opening');
      menu.classList.add('is-closing');
      closeTimer = window.setTimeout(finishClose, motionQuery.matches ? 10 : 340);
    };

    menu.addEventListener('toggle', () => {
      if (!menu.open || menu.classList.contains('is-closing')) return;
      menu.classList.add('is-opening');
      panel.getBoundingClientRect();
      requestAnimationFrame(() => {
        menu.classList.remove('is-opening');
        closeButton.focus({ preventScroll: true });
      });
    });

    closeButton.addEventListener('click', () => closeMenu());
    backdrop.addEventListener('click', () => closeMenu());

    panel.querySelectorAll('[data-mobile-menu-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) return;
        event.preventDefault();
        closeMenu(link.href);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!menu.open || menu.classList.contains('is-closing')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = focusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        closeButton.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches && menu.open) finishClose();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-about"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ns-about-carousel]').forEach((track) => {
    if (track.children.length < 2 || track.dataset.ready) return;
    track.dataset.ready = 'true';
    let index = 0;
    window.setInterval(() => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      index = (index + 1) % track.children.length;
      track.style.transform = `translateX(-${index * 100}%)`;
    }, 4500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-accessory-search"]) return;
  try {
    
  document.querySelectorAll('[data-accessory-search-form]').forEach((form) => {
    const input = form.querySelector('[data-accessory-search-input]');
    const query = form.querySelector('[data-accessory-search-query]');
    if (!input || !query) return;

    form.addEventListener('submit', () => {
      const term = input.value.trim();
      query.value = term ? `product_type:Accessori ${term}` : 'product_type:Accessori';
      input.removeAttribute('name');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-accessory-shop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-accessory-search-form]').forEach((form) => {
    const input = form.querySelector('[data-accessory-search-input]');
    const query = form.querySelector('[data-accessory-search-query]');
    if (!input || !query) return;

    form.addEventListener('submit', () => {
      const term = input.value.trim();
      query.value = term ? `product_type:Accessori ${term}` : 'product_type:Accessori';
      input.removeAttribute('name');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-boat-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boat-configurator')) {
    customElements.define('boat-configurator', class extends HTMLElement {
      async connectedCallback() {
        this.labels = JSON.parse(this.querySelector('[data-configurator-labels]').textContent);
        const assets = JSON.parse(this.querySelector('[data-configurator-assets]').textContent);
        this.stage = this.querySelector('[data-stage]');
        this.loading = this.querySelector('[data-loading]');
        this.error = this.querySelector('[data-error]');
        this.quotePanel = this.querySelector('[data-quote-panel]');
        this.quoteForm = this.querySelector('.ns-configurator__quote-form');
        this.contactOutcome = this.querySelector('[data-contact-outcome]');
        this.stateKey = `ns-configurator-state-v1:${window.location.pathname}`;
        this.currentStep = 'brand';
        this.brandId = null;
        this.model = null;
        this.selectedEngineId = null;
        this.selected = new Set();
        this.requestReference = null;
        this.submitting = false;
        this.images = assets.images;
        this.logos = assets.logos;
        try {
          const response = await fetch(this.dataset.catalogUrl);
          if (!response.ok) throw new Error('catalog');
          this.catalog = await response.json();
          this.loading.hidden = true;
          this.stage.hidden = false;
          this.bindSteps();
          this.bindQuoteForm();
          this.restoreState();
        } catch (error) {
          this.loading.hidden = true;
          this.error.hidden = false;
        }
      }

      bindSteps() {
        this.querySelectorAll('[data-step-target]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            if (button.dataset.stepTarget === 'brand') this.renderBrand();
            if (button.dataset.stepTarget === 'model' && this.brandId) this.renderModel();
            if (button.dataset.stepTarget === 'accessories' && this.model) this.renderAccessories();
          });
        });
      }

      escape(value) {
        return String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#039;' })[character]);
      }

      money(value) {
        if (value === null || value === undefined) return this.labels.notAvailable;
        return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style:'currency', currency:'EUR' }).format(value);
      }

      readState() {
        try {
          return JSON.parse(sessionStorage.getItem(this.stateKey) || 'null');
        } catch (error) {
          return null;
        }
      }

      modelRevision(model = this.model) {
        if (!model) return null;
        return `${model.source?.file || ''}:${model.source?.range || ''}`;
      }

      persistState() {
        if (!this.brandId) {
          sessionStorage.removeItem(this.stateKey);
          return;
        }
        sessionStorage.setItem(this.stateKey, JSON.stringify({
          brandId:this.brandId,
          modelId:this.model?.id || null,
          modelRevision:this.modelRevision(),
          selectedEngineId:this.selectedEngineId,
          selected:[...this.selected],
          step:this.currentStep,
          requestReference:this.requestReference
        }));
      }

      restoreState() {
        const saved = this.readState();
        const model = saved && this.catalog.models.find((item) => item.id === saved.modelId);
        const brandId = model?.brandId || saved?.brandId;
        if (!brandId || !this.catalog.models.some((item) => item.brandId === brandId)) {
          this.renderBrand();
          return;
        }
        this.brandId = brandId;
        if (!model) {
          this.renderModel();
          return;
        }
        this.model = model;
        const currentRevision = this.modelRevision(model);
        const revisionChanged = Boolean(saved.modelRevision && saved.modelRevision !== currentRevision);
        const legacySaver330 = model.id === 'saver-330-walk-around' && saved.modelRevision !== currentRevision;
        if (revisionChanged || legacySaver330) {
          this.selectedEngineId = null;
          this.selected = new Set();
          this.requestReference = null;
          this.renderModel();
          return;
        }
        const engineIds = new Set(model.engine.options.map((option) => option.id));
        this.selectedEngineId = model.engine.mode === 'fixed'
          ? model.engine.options[0]?.id || null
          : engineIds.has(saved.selectedEngineId) ? saved.selectedEngineId : null;
        this.selected = new Set();
        (saved.selected || [])
          .filter((index) => Number.isInteger(index) && index >= 0 && index < model.accessories.length)
          .forEach((index) => this.setAccessorySelection(index, true));
        this.requestReference = saved.requestReference || null;
        const hasOutcome = this.contactOutcome.dataset.success === 'true' || this.contactOutcome.dataset.errors === 'true';
        if ((hasOutcome || saved.step === 'summary') && this.engineReady()) this.renderSummary({ showQuote:this.contactOutcome.dataset.errors === 'true' || this.contactOutcome.dataset.success === 'true' });
        else if (saved.step === 'model') this.renderModel();
        else if (saved.step === 'accessories') this.renderAccessories();
        else this.renderBrand();
      }

      setStep(step) {
        this.currentStep = step;
        const order = ['brand', 'model', 'accessories'];
        const activeIndex = order.indexOf(step === 'summary' ? 'accessories' : step);
        this.querySelectorAll('[data-step-target]').forEach((button, index) => {
          button.disabled = index > activeIndex || index === 1 && !this.brandId || index === 2 && !this.model;
          button.toggleAttribute('data-completed', step === 'summary' || index < activeIndex);
          if (index === activeIndex && step !== 'summary') button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        this.persistState();
      }

      selectedEngine(model = this.model) {
        if (!model) return null;
        if (model.engine.mode === 'fixed') return model.engine.options[0] || null;
        return model.engine.options.find((option) => option.id === this.selectedEngineId) || null;
      }

      engineReady(model = this.model) {
        return Boolean(this.selectedEngine(model));
      }

      getPricing(model, engine) {
        return {
          mode:model.pricing.mode || 'base_plus_engine',
          boat:model.pricing.boatBasePrice,
          engine:engine?.price ?? null,
          inherentlyPartial:Boolean(model.pricing.inherentlyPartial)
        };
      }

      getSelection() {
        const accessories = this.model.accessories.filter((item, index) => this.selected.has(index));
        const engine = this.selectedEngine();
        const pricing = this.getPricing(this.model, engine);
        const knownAccessories = accessories.reduce((sum, item) => sum + (item.price || 0), 0);
        const complete = Boolean(engine);
        const partial = pricing.inherentlyPartial || engine?.price === null || accessories.some((item) => item.price === null);
        const baseAndEngine = pricing.mode === 'combined_configuration'
          ? pricing.engine || 0
          : (pricing.boat || 0) + (pricing.engine || 0);
        return { accessories, engine, pricing, complete, partial, total:baseAndEngine + knownAccessories };
      }

      imageMarkup(model, className = 'ns-configurator__image') {
        const source = model ? this.images[model.id] || this.dataset.genericImage : this.dataset.genericImage;
        const alt = model ? model.primaryImage.alt : '';
        return `<div class="${className}"><img src="${this.escape(source)}" alt="${this.escape(alt)}" width="1600" height="900"></div>`;
      }

      previewModelForBrand() {
        if (!this.brandId) return null;
        return this.model?.brandId === this.brandId
          ? this.model
          : this.catalog.models.find((model) => model.brandId === this.brandId) || null;
      }

      renderBrand() {
        this.setStep('brand');
        const brands = [...new Map(this.catalog.models.map((model) => [model.brandId, { id:model.brandId, label:model.brand }])).values()];
        const choices = brands.map((brand) => `
          <button class="ns-configurator__choice" type="button" data-brand="${this.escape(brand.id)}" aria-pressed="${this.brandId === brand.id}">
            <span class="ns-configurator__choice-brand">
              <span class="ns-configurator__choice-logo ns-configurator__choice-logo--${this.escape(brand.id)}"><img src="${this.escape(this.logos[brand.id])}" alt="" width="180" height="80"></span>
              <span class="ns-configurator__choice-brand-name">${this.escape(brand.label)}</span>
            </span>
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m9 5 7 7-7 7"></path></svg>
          </button>`).join('');
        this.stage.innerHTML = `
          <section class="ns-configurator__choice-screen">
            <div class="ns-configurator__choice-copy">
              <h2>${this.escape(this.labels.chooseBrand)}</h2>
              <p>${this.escape(this.labels.chooseBrandHelp)}</p>
              <div class="ns-configurator__choices">${choices}</div>
              <div class="ns-configurator__actions"><span></span><button class="ns-configurator__button ns-cta ns-cta--primary" type="button" data-continue disabled>${this.escape(this.labels.continue)}</button></div>
            </div>
            ${this.imageMarkup(this.previewModelForBrand(), 'ns-configurator__choice-image')}
          </section>`;
        this.stage.querySelectorAll('[data-brand]').forEach((button) => {
          button.addEventListener('click', () => {
            if (this.brandId !== button.dataset.brand) {
              this.brandId = button.dataset.brand;
              this.model = null;
              this.selectedEngineId = null;
              this.selected = new Set();
              this.requestReference = null;
            }
            this.renderBrand();
          });
        });
        if (this.brandId) {
          const next = this.stage.querySelector('[data-continue]');
          next.disabled = false;
          next.addEventListener('click', () => this.renderModel());
        }
      }

      renderModel() {
        this.setStep('model');
        const models = this.catalog.models.filter((model) => model.brandId === this.brandId);
        const choices = models.map((model) => `
          <button class="ns-configurator__choice" type="button" aria-pressed="${this.model?.id === model.id}" data-model="${this.escape(model.id)}">
            <span>${this.escape(model.model)}</span>
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m9 5 7 7-7 7"></path></svg>
          </button>`).join('');
        this.stage.innerHTML = `
          <section class="ns-configurator__choice-screen ns-configurator__choice-screen--models">
            <div class="ns-configurator__choice-copy ns-configurator__choice-copy--models">
              <h2>${this.escape(this.labels.chooseModel)}</h2>
              <p>${this.escape(this.labels.chooseModelHelp)}</p>
              <div class="ns-configurator__choices ns-configurator__choices--models">${choices}</div>
              <div class="ns-configurator__actions">
                <button class="ns-configurator__button ns-configurator__button--secondary ns-cta ns-cta--secondary" type="button" data-back>${this.escape(this.labels.back)}</button>
                <button class="ns-configurator__button ns-cta ns-cta--primary" type="button" data-continue ${this.model ? '' : 'disabled'}>${this.escape(this.labels.continue)}</button>
              </div>
            </div>
            ${this.imageMarkup(this.previewModelForBrand(), 'ns-configurator__choice-image')}
          </section>`;
        this.stage.querySelector('[data-back]').addEventListener('click', () => this.renderBrand());
        this.stage.querySelectorAll('[data-model]').forEach((button) => {
          button.addEventListener('click', () => {
            if (this.model?.id !== button.dataset.model) {
              this.model = models.find((model) => model.id === button.dataset.model);
              this.selectedEngineId = this.model.engine.mode === 'fixed' ? this.model.engine.options[0]?.id || null : null;
              this.selected = new Set();
              this.requestReference = null;
            }
            this.stage.querySelectorAll('[data-model]').forEach((modelButton) => {
              modelButton.setAttribute('aria-pressed', String(modelButton.dataset.model === this.model.id));
            });
            const image = this.stage.querySelector('.ns-configurator__choice-image img');
            image.src = this.images[this.model.id] || this.dataset.genericImage;
            image.alt = this.model.primaryImage.alt;
            this.stage.querySelector('[data-continue]').disabled = false;
            this.persistState();
          });
        });
        this.stage.querySelector('[data-continue]').addEventListener('click', () => this.renderAccessories());
      }

      factsMarkup(items) {
        return `<div class="ns-configurator__facts">${items.map((item) => `<div class="ns-configurator__fact"><span>${this.escape(item.label)}</span><strong>${this.escape(item.value)}</strong></div>`).join('')}</div>`;
      }

      standardsMarkup(model) {
        return model.standardEquipmentGroups.map((group) => `
          <h3>${this.escape(group.label)}</h3>
          <ul class="ns-configurator__standard-list">${group.items.map((item) => `<li>${this.escape(item)}</li>`).join('')}</ul>`).join('');
      }

      engineMarkup(model) {
        if (model.engine.mode === 'fixed') {
          const engine = model.engine.options[0];
          const facts = [...(engine.details || []), { label:this.labels.enginePackage, value:this.money(engine.price) }];
          return `
            <details class="ns-configurator__accessory-details">
              <summary><span>${this.escape(this.labels.engine)}</span><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"></path></svg></summary>
              <div class="ns-configurator__accessory-details-body"><p><strong>${this.escape(engine.label)}</strong>${engine.quantity ? ` · ${this.escape(this.labels.quantity)} ${engine.quantity}` : ''}</p>${this.factsMarkup(facts)}</div>
            </details>`;
        }
        const options = model.engine.options.map((engine) => {
          const components = engine.priceComponents.length > 1
            ? engine.priceComponents.map((component) => `${component.label}: ${this.money(component.price)}`).join(' · ')
            : (engine.details || []).map((detail) => detail.value).join(' · ');
          return `
            <label class="ns-configurator__engine-option">
              <input type="radio" name="configurator-engine" value="${this.escape(engine.id)}" ${this.selectedEngineId === engine.id ? 'checked' : ''}>
              <span>${this.escape(engine.label)}</span>
              <strong>${this.money(engine.price)}</strong>
              ${components ? `<small>${this.escape(components)}</small>` : ''}
            </label>`;
        }).join('');
        const help = model.pricing.mode === 'combined_configuration'
          ? this.labels.chooseCombinedEngineHelp
          : this.labels.chooseEngineHelp;
        return `
          <fieldset class="ns-configurator__engine-selector">
            <legend>${this.escape(this.labels.chooseEngine)}</legend>
            <p>${this.escape(help)}</p>
            <div class="ns-configurator__engine-options">${options}</div>
            <p class="ns-configurator__engine-required" data-engine-required ${this.engineReady(model) ? 'hidden' : ''}>${this.escape(this.labels.engineRequired)}</p>
          </fieldset>`;
      }

      categoryLabel(category) {
        return category === 'service' ? this.labels.categoryService : this.labels.categoryAccessory;
      }

      setAccessorySelection(index, checked) {
        if (!checked) {
          this.selected.delete(index);
          return;
        }
        const accessory = this.model?.accessories[index];
        if (!accessory) return;
        const exclusions = new Set(accessory.excludes || []);
        this.model.accessories.forEach((candidate, candidateIndex) => {
          if (exclusions.has(candidate.id)) this.selected.delete(candidateIndex);
        });
        this.selected.add(index);
      }

      accessoryCategoriesMarkup(model) {
        const groups = this.catalog.accessoryCategories.map((category, categoryIndex) => {
          const options = model.accessories
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => (item.category || model.defaultAccessoryCategory) === category);
          if (!options.length) return '';
          const fields = options.map(({ item, index }) => `
            <label class="ns-configurator__option">
              <input type="checkbox" value="${index}" ${this.selected.has(index) ? 'checked' : ''}>
              <span>${this.escape(item.label)}</span>
              <strong>${this.money(item.price)}</strong>
            </label>`).join('');
          return `
            <details class="ns-configurator__accessory-category" data-accessory-category="${this.escape(category)}" ${categoryIndex === 0 ? 'open' : ''}>
              <summary><span>${this.escape(this.categoryLabel(category))} <b>${options.length}</b></span><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"></path></svg></summary>
              <div class="ns-configurator__options">${fields}</div>
            </details>`;
        }).filter(Boolean);
        return groups.length ? groups.join('') : `<p>${this.escape(this.labels.noAccessories)}</p>`;
      }

      priceMarkup(selection) {
        const label = selection.complete
          ? selection.partial ? this.labels.partialPrice : this.labels.price
          : this.labels.engineRequired;
        return `
          <div class="ns-configurator__total">
            <small>${this.escape(label)}</small>
            <strong>${this.money(selection.total)}</strong>
            ${selection.complete && selection.partial ? `<p class="ns-configurator__partial"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6M12 7h.01"></path></svg><span>${this.escape(this.labels.partialHelp)}</span></p>` : ''}
          </div>`;
      }

      updatePricebars() {
        const selection = this.getSelection();
        this.stage.querySelectorAll('[data-pricebar] .ns-configurator__total').forEach((total) => {
          total.outerHTML = this.priceMarkup(selection);
        });
        this.stage.querySelectorAll('[data-summary]').forEach((button) => {
          button.disabled = !selection.complete;
        });
        const required = this.stage.querySelector('[data-engine-required]');
        if (required) required.hidden = selection.complete;
      }

      renderAccessories() {
        this.setStep('accessories');
        this.quotePanel.hidden = true;
        const model = this.model;
        const selection = this.getSelection();
        const standardCount = model.standardEquipmentGroups.reduce((sum, group) => sum + group.items.length, 0);
        this.stage.innerHTML = `
          <section class="ns-configurator__accessory-layout">
            <aside class="ns-configurator__accessory-sidebar">
              <header class="ns-configurator__panel-head"><div><small>${this.escape(this.labels.brand)}</small><strong>${this.escape(model.brand)}</strong></div><div><small>${this.escape(this.labels.model)}</small><strong>${this.escape(model.model)}</strong></div></header>
              ${this.imageMarkup(model, 'ns-configurator__accessory-image')}
              <footer class="ns-configurator__accessory-pricebar ns-configurator__accessory-pricebar--desktop" data-pricebar>${this.priceMarkup(selection)}<button class="ns-configurator__button ns-cta ns-cta--primary" type="button" data-summary ${selection.complete ? '' : 'disabled'}>${this.escape(this.labels.goToSummary)}</button></footer>
            </aside>
            <div class="ns-configurator__accessory-content">
              ${this.engineMarkup(model)}
              <details class="ns-configurator__accessory-details">
                <summary><span>${this.escape(this.labels.technicalData)}</span><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"></path></svg></summary>
                <div class="ns-configurator__accessory-details-body">${this.factsMarkup(model.technicalSpecs)}</div>
              </details>
              ${standardCount ? `<details class="ns-configurator__accessory-details ns-configurator__accessory-details--standard">
                <summary><span>${this.escape(this.labels.standardEquipment)} <b>${standardCount}</b></span><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"></path></svg></summary>
                <div class="ns-configurator__accessory-details-body">${this.standardsMarkup(model)}</div>
              </details>` : ''}
              ${this.accessoryCategoriesMarkup(model)}
            </div>
            <footer class="ns-configurator__accessory-pricebar ns-configurator__accessory-pricebar--mobile" data-pricebar>${this.priceMarkup(selection)}<button class="ns-configurator__button ns-cta ns-cta--primary" type="button" data-summary ${selection.complete ? '' : 'disabled'}>${this.escape(this.labels.goToSummary)}</button></footer>
          </section>
          <div class="ns-configurator__actions"><button class="ns-configurator__button ns-configurator__button--secondary ns-cta ns-cta--secondary" type="button" data-back>${this.escape(this.labels.back)}</button></div>`;
        this.stage.querySelectorAll('.ns-configurator__engine-option input').forEach((input) => {
          input.addEventListener('change', () => {
            this.selectedEngineId = input.value;
            this.persistState();
            this.updatePricebars();
          });
        });
        this.stage.querySelectorAll('.ns-configurator__option input').forEach((input) => {
          input.addEventListener('change', () => {
            const index = Number(input.value);
            this.setAccessorySelection(index, input.checked);
            this.stage.querySelectorAll('.ns-configurator__option input').forEach((checkbox) => {
              checkbox.checked = this.selected.has(Number(checkbox.value));
            });
            this.persistState();
            this.updatePricebars();
          });
        });
        this.stage.querySelectorAll('[data-summary]').forEach((button) => button.addEventListener('click', () => {
          if (this.engineReady()) this.renderSummary();
        }));
        this.stage.querySelector('[data-back]').addEventListener('click', () => this.renderModel());
      }

      renderSummary({ showQuote = false } = {}) {
        const model = this.model;
        const selection = this.getSelection();
        if (!selection.complete) {
          this.renderAccessories();
          return;
        }
        this.setStep('summary');
        const accessoryLines = selection.accessories.length ? selection.accessories.map((item) => `<div class="ns-configurator__line"><span>${this.escape(item.label)}</span><strong>${this.money(item.price)}</strong></div>`).join('') : `<p>${this.escape(this.labels.noAccessories)}</p>`;
        const combinedConfiguration = selection.pricing.mode === 'combined_configuration';
        const componentLabel = combinedConfiguration ? this.labels.configurationComponents : this.labels.engineComponents;
        const engineComponentLines = selection.engine.priceComponents.length
          ? `<div class="ns-configurator__engine-components"><small>${this.escape(componentLabel)}</small>${selection.engine.priceComponents.map((component) => `<div class="ns-configurator__line ns-configurator__line--component"><span>${this.escape(component.label)}</span><strong>${this.money(component.price)}</strong></div>`).join('')}</div>`
          : '';
        const configurationPriceLines = combinedConfiguration
          ? `<div class="ns-configurator__line"><span>${this.escape(this.labels.configurationPrice)}</span><strong>${this.money(selection.pricing.engine)}</strong></div>`
          : `<div class="ns-configurator__line"><span>${this.escape(this.labels.boat)}</span><strong>${this.money(selection.pricing.boat)}</strong></div><div class="ns-configurator__line"><span>${this.escape(selection.engine.label)}</span><strong>${this.money(selection.pricing.engine)}</strong></div>`;
        const standardCard = model.standardEquipmentGroups.length
          ? `<section class="ns-configurator__summary-card ns-configurator__summary-card--standard"><h3><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3Z"></path></svg>${this.escape(this.labels.standardEquipment)}</h3><div class="ns-configurator__summary-standard-lists">${model.standardEquipmentGroups.map((group) => `<ul class="ns-configurator__summary-list">${group.items.map((item) => `<li>${this.escape(item)}</li>`).join('')}</ul>`).join('')}</div></section>`
          : '';
        this.stage.innerHTML = `
          <section class="ns-configurator__summary">
            <div class="ns-configurator__print-header"><strong>NS NAUTICA</strong><span>${this.escape(this.labels.summary)}</span></div>
            <header class="ns-configurator__summary-hero">
              ${this.imageMarkup(model, 'ns-configurator__summary-visual')}
              <div class="ns-configurator__summary-identity">
                <span class="ns-configurator__summary-eyebrow">${this.escape(this.labels.summary)}</span>
                <p class="ns-configurator__summary-brand">${this.escape(model.brand)}</p>
                <h2 class="ns-configurator__summary-model">${this.escape(model.model)}</h2>
                <p class="ns-configurator__summary-engine"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M7 4h10l2 5v8l-3 3H8l-3-3V9l2-5Z"></path><path d="M8 9h8M9 20v2M15 20v2"></path></svg><span><span class="ns-configurator__summary-label">${this.escape(this.labels.engine)}</span>${this.escape(selection.engine.label)}</span></p>
                <div class="ns-configurator__summary-hero-price">${this.priceMarkup(selection)}</div>
              </div>
            </header>
            <div class="ns-configurator__summary-content">
              <section class="ns-configurator__summary-card ns-configurator__summary-card--specs"><h3><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"></circle><path d="M12 3v18M3 12h18M6 6l12 12M18 6 6 18"></path></svg>${this.escape(this.labels.technicalData)}</h3>${this.factsMarkup(model.technicalSpecs)}</section>
              <section class="ns-configurator__summary-card ns-configurator__summary-card--price"><h3><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 13 11 22l-9-9V4h9l9 9Z"></path><circle cx="7.5" cy="9.5" r="1.5"></circle></svg>${this.escape(this.labels.selectedAccessories)}</h3>${configurationPriceLines}${engineComponentLines}${accessoryLines}<div class="ns-configurator__summary-price">${this.priceMarkup(selection)}</div></section>
              ${standardCard}
            </div>
            <footer class="ns-configurator__summary-actions">
              <div class="ns-configurator__summary-cta">
                <button class="ns-configurator__button ns-cta ns-cta--primary" type="button" data-request-quote>${this.escape(this.labels.requestQuote)}</button>
              </div>
              <div class="ns-configurator__summary-secondary" aria-label="${this.escape(this.labels.secondaryActions)}">
                <button class="ns-configurator__text-action" type="button" data-edit><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m4 20 4.2-1 10.5-10.5a2.1 2.1 0 0 0-3-3L5.2 16 4 20Z"></path><path d="m13.8 7.4 3 3"></path></svg>${this.escape(this.labels.edit)}</button>
                <button class="ns-configurator__text-action" type="button" data-print>${this.escape(this.labels.print)}</button>
              </div>
            </footer>
          </section>
        `;
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        this.stage.querySelector('[data-print]').addEventListener('click', () => window.print());
        this.stage.querySelector('[data-edit]').addEventListener('click', () => this.renderAccessories());
        this.stage.querySelector('[data-request-quote]').addEventListener('click', () => this.openQuoteForm());
        if (showQuote) this.openQuoteForm({ focus:false });
        else this.quotePanel.hidden = true;
      }

      bindQuoteForm() {
        this.quotePanel.addEventListener('submit', (event) => {
          const quoteForm = event.target.closest('.ns-configurator__quote-form');
          if (!quoteForm) return;
          this.quoteForm = quoteForm;
          if (this.submitting) {
            event.preventDefault();
            return;
          }
          if (!quoteForm.checkValidity()) return;
          this.prepareQuotePayload();
          this.submitting = true;
          const button = quoteForm.querySelector('[data-contact-submit]');
          button.disabled = true;
          button.querySelector('[data-submit-label]').textContent = this.labels.sendingRequest;
          this.persistState();
        });
      }

      syncQuoteForm() {
        this.quoteForm = this.quotePanel.querySelector('.ns-configurator__quote-form') || this.quoteForm;
        return this.quoteForm;
      }

      openQuoteForm({ focus = true } = {}) {
        this.quotePanel.hidden = false;
        const success = this.contactOutcome.dataset.success === 'true';
        this.syncQuoteForm().querySelector('[data-contact-fields]').hidden = success;
        this.prepareQuotePayload();
        requestAnimationFrame(() => {
          this.syncQuoteForm();
          this.prepareQuotePayload();
          if (focus) {
            this.quotePanel.scrollIntoView({ behavior:'smooth', block:'start' });
            this.quoteForm.querySelector('input[name="contact[name]"]')?.focus();
          } else {
            this.quotePanel.querySelector('[role="status"],[role="alert"]')?.focus();
          }
        });
      }

      prepareQuotePayload() {
        this.quotePanel.dataset.payloadState = 'preparing';
        this.syncQuoteForm();
        const selection = this.getSelection();
        this.requestReference ||= window.crypto?.randomUUID?.() || `NS-${Date.now()}`;
        const grouped = this.catalog.accessoryCategories.map((category) => {
          const items = selection.accessories.filter((item) => (item.category || this.model.defaultAccessoryCategory) === category);
          if (!items.length) return '';
          return `${this.categoryLabel(category)}:\n${items.map((item) => `- ${item.label}: ${this.money(item.price)}`).join('\n')}`;
        }).filter(Boolean);
        const timestamp = new Date().toISOString();
        const configuration = `${this.model.brand} ${this.model.model}`;
        const total = `${selection.partial ? this.labels.partialPrice : this.labels.price}: ${this.money(selection.total)}`;
        const combinedConfiguration = selection.pricing.mode === 'combined_configuration';
        const componentLabel = combinedConfiguration ? this.labels.configurationComponents : this.labels.engineComponents;
        const engineComponents = selection.engine.priceComponents.length
          ? `${componentLabel}:\n${selection.engine.priceComponents.map((component) => `- ${component.label}: ${this.money(component.price)}`).join('\n')}`
          : '';
        const engineSummary = [
          `Motore: ${selection.engine.label}`,
          engineComponents,
          `${combinedConfiguration ? this.labels.configurationPrice : this.labels.enginePackage}: ${this.money(selection.pricing.engine)}`
        ].filter(Boolean).join('\n');
        const body = [
          `Richiesta di preventivo — ${configuration}`,
          `Riferimento: ${this.requestReference}`,
          engineSummary,
          total,
          grouped.length ? grouped.join('\n\n') : this.labels.noAccessories,
          `Timestamp: ${timestamp}`
        ].join('\n\n');
        const payload = this.quoteForm.querySelector('[data-contact-body]');
        payload.defaultValue = body;
        payload.value = body;
        payload.textContent = body;
        this.quotePanel.dataset.payloadState = 'ready';
        this.quotePanel.dataset.payloadLength = String(body.length);
        this.persistState();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-market-home"]) return;
  try {
    
  const syncFeaturedCatalog = () => {
    document.querySelectorAll('.ns-market-home').forEach((root) => {
      const extraGrid = root.querySelector('[data-market-featured-extra]');
      const viewAll = root.querySelector('[data-market-view-all]');
      if (!extraGrid || !viewAll) return;

      const expanded = window.location.hash === '#MarketAll';
      extraGrid.hidden = !expanded;
      viewAll.hidden = expanded;
    });
  };

  document.querySelectorAll('[data-market-view-all]').forEach((viewAll) => {
    viewAll.addEventListener('click', (event) => {
      const target = new URL(viewAll.href, window.location.href);
      if (target.pathname !== window.location.pathname) return;

      event.preventDefault();
      const extraGrid = viewAll.closest('.ns-market-home')?.querySelector('[data-market-featured-extra]');
      if (!extraGrid) return;

      extraGrid.hidden = false;
      viewAll.hidden = true;
      window.location.hash = 'MarketAll';
      extraGrid.focus({ preventScroll: true });
      extraGrid.scrollIntoView({ block: 'start' });
    });
  });

  syncFeaturedCatalog();
  window.addEventListener('hashchange', syncFeaturedCatalog);
  window.addEventListener('popstate', syncFeaturedCatalog);

  const syncMarketResultsMode = () => {
    document.querySelectorAll('.ns-market-home').forEach((root) => {
      const query = new URLSearchParams(window.location.search);
      const hasFilters = [...query.keys()].some((key) => key.startsWith('filter.'));
      if (!hasFilters) return;

      root.classList.add('ns-market-home--results');
      const resultsTitle = root.querySelector('[data-market-results-title]');
      const featuredTitle = root.querySelector('[data-market-featured-title]');
      const resultsCount = root.querySelector('[data-market-results-count]');
      const resultsRegion = root.querySelector('[data-market-results-region]');
      const activeFilters = root.querySelector('[data-market-active-filters]');
      const filterPanel = root.querySelector('[data-market-filter-panel]');
      const filterSummary = root.querySelector('[data-market-filter-summary]');

      if (resultsTitle) resultsTitle.hidden = false;
      if (featuredTitle) featuredTitle.hidden = true;
      if (resultsCount) resultsCount.hidden = false;
      if (resultsRegion && resultsTitle) {
        resultsRegion.setAttribute('aria-labelledby', resultsTitle.id);
      }
      if (filterPanel) filterPanel.hidden = false;
      if (activeFilters) activeFilters.hidden = false;

      window.requestAnimationFrame(() => {
        if (!filterPanel || !filterSummary) return;
        const selections = [...filterPanel.querySelectorAll('select')]
          .filter((select) => select.value)
          .map((select) => select.selectedOptions[0]?.textContent.trim())
          .filter(Boolean);
        if (selections.length > 0) {
          filterSummary.textContent = `${filterSummary.dataset.defaultLabel}: ${selections.join(' · ')}`;
        }
        if (activeFilters && activeFilters.children.length === 0) {
          selections.forEach((selection) => {
            const chip = document.createElement('span');
            chip.textContent = selection;
            activeFilters.append(chip);
          });
        }
      });
    });
  };

  syncMarketResultsMode();

  document.querySelectorAll('[data-market-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-market-product"]) return;
  try {
    
  document.querySelectorAll('[data-market-back]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!document.referrer || window.history.length <= 1) return;
      event.preventDefault();
      window.history.back();
    });
  });
  document.querySelectorAll('[data-market-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-market-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-market-gallery-thumb]')];
    const dialog = gallery.querySelector('[data-market-gallery-dialog]');
    const dialogSlides = [...gallery.querySelectorAll('[data-market-gallery-dialog-slide]')];
    const dialogThumbs = [...gallery.querySelectorAll('[data-market-gallery-dialog-thumb]')];
    const counters = [...gallery.querySelectorAll('[data-market-gallery-counter]')];
    const previous = gallery.querySelector('[data-market-gallery-previous]');
    const next = gallery.querySelector('[data-market-gallery-next]');
    const close = gallery.querySelector('[data-market-gallery-close]');
    const viewer = gallery.querySelector('[data-market-gallery-viewer]');
    let activeIndex = 0;
    let lastOpener = null;
    let touchStartX = 0;

    const selectMedia = (requestedIndex, moveThumbnail = true) => {
      if (!slides.length) return;
      activeIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => { slide.hidden = index !== activeIndex; });
      dialogSlides.forEach((slide, index) => { slide.hidden = index !== activeIndex; });
      thumbs.forEach((thumb, index) => {
        if (index === activeIndex) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      dialogThumbs.forEach((thumb, index) => {
        if (index === activeIndex) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      counters.forEach((counter) => { counter.textContent = `${activeIndex + 1} / ${slides.length}`; });

      if (moveThumbnail) {
        thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        dialogThumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => selectMedia(Number(thumb.dataset.mediaIndex)));
    });
    dialogThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => selectMedia(Number(thumb.dataset.mediaIndex)));
    });
    gallery.querySelectorAll('[data-market-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog) return;
        lastOpener = button;
        dialog.showModal();
        selectMedia(activeIndex, false);
        close?.focus();
      });
    });

    previous?.addEventListener('click', () => selectMedia(activeIndex - 1));
    next?.addEventListener('click', () => selectMedia(activeIndex + 1));
    close?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog?.addEventListener('close', () => lastOpener?.focus());
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') selectMedia(activeIndex - 1);
      if (event.key === 'ArrowRight') selectMedia(activeIndex + 1);
      if (event.key === 'Home') selectMedia(0);
      if (event.key === 'End') selectMedia(slides.length - 1);
    });
    viewer?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    viewer?.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 50) return;
      selectMedia(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
  });
  document.querySelectorAll('[data-market-product-share]').forEach((button) => {
    button.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: location.href });
        } else {
          await navigator.clipboard.writeText(location.href);
        }
      } catch (exception) {
        if (!exception || exception.name !== 'AbortError') button.textContent = location.href;
      }
    });
  });
  document.querySelectorAll('[data-market-mobile-cta]').forEach((link) => {
    link.addEventListener('click', () => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      requestAnimationFrame(() => target.focus({ preventScroll: true }));
    });
  });
  document.querySelectorAll('[data-market-rental-cta]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const calculator = document.querySelector(link.getAttribute('href'));
      if (!calculator) return;
      event.preventDefault();
      calculator.open = true;
      calculator.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center',
      });
      requestAnimationFrame(() => calculator.querySelector('summary')?.focus({ preventScroll: true }));
    });
  });
  document.querySelectorAll('[data-rental-calculator]').forEach((calculator) => {
    const input = calculator.querySelector('[data-rental-days-input]');
    const rate = Number(calculator.dataset.dailyRate);
    const threshold = Number(calculator.dataset.discountThreshold);
    const percent = Number(calculator.dataset.discountPercent);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    });

    const update = () => {
      if (!input || !Number.isFinite(rate) || rate <= 0) return;
      const days = Number(input.value);
      const baseTotal = days * rate;
      const discount = days >= threshold ? Math.round(baseTotal * percent / 100) : 0;
      const total = baseTotal - discount;
      const dayLabel = days === 1 ? calculator.dataset.daySingular : calculator.dataset.dayPlural;
      const daysOutput = calculator.querySelector('[data-rental-days]');
      const dailyOutput = calculator.querySelector('[data-rental-daily-rate]');
      const baseOutput = calculator.querySelector('[data-rental-base-total]');
      const discountOutput = calculator.querySelector('[data-rental-discount]');
      const totalOutput = calculator.querySelector('[data-rental-total]');
      const discountRow = calculator.querySelector('[data-rental-discount-row]');
      const offer = calculator.querySelector('[data-rental-offer]');
      if (daysOutput) daysOutput.textContent = `${days} ${dayLabel}`;
      if (dailyOutput) dailyOutput.textContent = formatter.format(rate);
      if (baseOutput) baseOutput.textContent = formatter.format(baseTotal);
      if (discountOutput) discountOutput.textContent = `-${formatter.format(discount)}`;
      if (totalOutput) totalOutput.textContent = formatter.format(total);
      if (discountRow) discountRow.hidden = discount === 0;
      if (offer) offer.hidden = discount === 0;
      input.setAttribute('aria-valuetext', `${days} ${dayLabel}`);
    };

    input?.addEventListener('input', update);
    update();

    const params = new URLSearchParams(window.location.search);
    if (params.get('rental') === 'open') {
      calculator.open = true;
      const alignCalculator = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            calculator.scrollIntoView({ behavior: 'auto', block: 'start' });
          });
        });
      };

      if (document.readyState === 'complete') alignCalculator();
      else window.addEventListener('load', alignCalculator, { once: true });
      window.addEventListener('pageshow', alignCalculator);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-noleggio-parity"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-noleggio-catalog]').forEach((catalog) => {
    let activeFilter = 'all';
    const applyFilter = () => {
      let visibleCount = 0;
      catalog.querySelectorAll('[data-noleggio-card]').forEach((card) => {
        card.hidden = activeFilter !== 'all' && card.dataset.productType !== activeFilter;
        if (!card.hidden) visibleCount += 1;
      });
      const emptyState = catalog.querySelector('[data-noleggio-empty]');
      if (emptyState) emptyState.hidden = visibleCount > 0;
    };

    catalog.querySelectorAll('[data-noleggio-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.noleggioFilter;
        catalog.querySelectorAll('[data-noleggio-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        applyFilter();
      });
    });

    const reset = catalog.querySelector('[data-noleggio-reset]');
    if (reset) {
      reset.addEventListener('click', () => {
        const allButton = catalog.querySelector('[data-noleggio-filter="all"]');
        if (allButton) allButton.click();
      });
    }

    const loadMore = catalog.querySelector('[data-noleggio-load-more]');
    if (loadMore) {
      loadMore.addEventListener('click', async (event) => {
        event.preventDefault();
        if (loadMore.getAttribute('aria-busy') === 'true') return;
        loadMore.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(loadMore.href);
          if (!response.ok) throw new Error('Unable to load more products');
          const html = await response.text();
          const documentNext = new DOMParser().parseFromString(html, 'text/html');
          const catalogNext = documentNext.querySelector('[data-noleggio-catalog]');
          const grid = catalog.querySelector('[data-noleggio-grid]');
          catalogNext.querySelectorAll('[data-noleggio-card]').forEach((card) => grid.append(card));
          const nextLink = catalogNext.querySelector('[data-noleggio-load-more]');
          if (nextLink) loadMore.href = nextLink.href;
          else loadMore.closest('.noleggio-load-more').remove();
          applyFilter();
        } catch (error) {
          window.location.href = loadMore.href;
        } finally {
          loadMore.removeAttribute('aria-busy');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-vendita-parity"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-buy-filter]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const condition = form.querySelector('[data-buy-condition]').value;
      const type = form.querySelector('[data-buy-type]').value;
      if (condition === 'new') {
        window.location.assign(form.dataset.newUrl);
        return;
      }
      const destination = condition === 'used' ? form.dataset.usedUrl : form.dataset.catalogUrl;
      const url = new URL(destination, window.location.origin);
      if (type) url.searchParams.set('filter.p.product_type', type);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-product-track]');
    const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const target = document.getElementById(thumb.dataset.target);
      if (!target || !track) return;
      track.scrollTo({ left: target.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      thumbs.forEach(item => { item.classList.remove('is-active'); item.removeAttribute('aria-current'); });
      thumb.classList.add('is-active'); thumb.setAttribute('aria-current', 'true');
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
